export const steps = ['I want to sync...', 'Field mapping', 'Frequency', 'Finish'];

export enum Step {
  CHOOSE,
  MAP,
  FREQUENCY,
  FINISH,
}
